// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__mVZmn","inputWrap":"styles_inputWrap__3OmxI","input":"styles_input__UT-FE"};